﻿import {ApiError} from "./apiError";

export class ApiRemoteError extends ApiError {
    public response: any;
    
    constructor(status: number, response: any) {
        super(status);
        this.response = response;
    }
}